import React, { useEffect, useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const tarotImages = ['https://cdn.magicpatterns.com/uploads/4ab7BSUdFMXZyk4MtvDNVf/v2_watermarked-75a06908-aad1-4c7e-9225-a6cbeed81049.jpg', 'https://cdn.magicpatterns.com/uploads/tB1PSra2y3YMgioBeCksXQ/ChatGPT_Image_16_may_2026,_13_44_03.png', 'https://cdn.magicpatterns.com/uploads/3NfEhnWKrF56AcVfhpM8Z6/ChatGPT_Image_16_may_2026,_13_46_08.png'];
const testimonials = [{
  quote: 'Me ayudó a entender exactamente lo que me estaba pasando.',
  name: 'C.G.',
  photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=200&auto=format&fit=crop&crop=faces'
}, {
  quote: 'Fue clara, directa y me dio mucha tranquilidad.',
  name: 'A.V.',
  photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=200&auto=format&fit=crop&crop=faces'
}, {
  quote: 'Recibí respuestas que necesitaba hace tiempo.',
  name: 'M.L.',
  photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=200&auto=format&fit=crop&crop=faces'
}];
const TarotCarousel = () => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex(prev => (prev + 1) % tarotImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);
  return <div className="relative w-full h-48 sm:h-56 overflow-hidden rounded-2xl border border-[#D4AF37]/40 shadow-[0_0_15px_rgba(212,175,55,0.2)]" data-id="element-0">
      <AnimatePresence mode="wait" data-id="element-1">
        <motion.img key={index} src={tarotImages[index]} initial={{
        opacity: 0,
        scale: 1.05
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.8
      }} className="absolute inset-0 w-full h-full object-cover" alt="Cartas del Tarot" data-id="element-2" />
      </AnimatePresence>
    </div>;
};
const TestimonialCarousel = () => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex(prev => (prev + 1) % testimonials.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  return <div className="relative w-full h-[220px] bg-black/50 backdrop-blur-md rounded-2xl border border-[#D4AF37]/30 shadow-[0_0_20px_rgba(0,0,0,0.5)] overflow-hidden" data-id="element-3">
      <AnimatePresence mode="wait" data-id="element-4">
        <motion.div key={index} initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -20
      }} transition={{
        duration: 0.5
      }} className="absolute inset-0 flex flex-col items-center justify-center text-center gap-3 p-5" data-id="element-5">
          <img src={testimonials[index].photo} alt={testimonials[index].name} className="w-14 h-14 rounded-full object-cover border-2 border-[#D4AF37]/80 shadow-[0_0_10px_rgba(212,175,55,0.4)]" data-id="element-6" />
          <div className="text-yellow-400 text-sm tracking-widest" data-id="element-7">★★★★★</div>
          <p className="text-sm sm:text-base text-gray-100 italic leading-snug" data-id="element-8">
            "{testimonials[index].quote}"
          </p>
          <p className="text-xs text-[#D4AF37] font-bold" data-id="element-9">
            — {testimonials[index].name}
          </p>
        </motion.div>
      </AnimatePresence>
      <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-2" data-id="element-10">
        {testimonials.map((_, i) => <div key={i} className={`w-1.5 h-1.5 rounded-full transition-colors ${i === index ? 'bg-[#D4AF37]' : 'bg-gray-600'}`} data-id="element-11" />)}
      </div>
    </div>;
};
const CTAButton = ({
  onClick
}: {
  onClick: () => void;
}) => <motion.a href="https://wa.me/5491140680259" target="_blank" rel="noopener noreferrer" onClick={onClick} className="block w-full py-4 px-4 bg-gradient-to-r from-yellow-600 via-yellow-500 to-yellow-600 text-black font-bold text-sm sm:text-base rounded-full border border-yellow-300 tracking-wide shadow-lg text-center" animate={{
  scale: [1, 1.04, 1],
  boxShadow: ['0px 0px 10px rgba(212,175,55,0.4)', '0px 0px 25px rgba(212,175,55,0.9)', '0px 0px 10px rgba(212,175,55,0.4)']
}} transition={{
  duration: 1.8,
  repeat: Infinity,
  ease: 'easeInOut'
}} data-id="element-12">
    👉 QUIERO MI CONSULTA AHORA
  </motion.a>;
export function App() {
  useEffect(() => {
    try {
      // Avoid double-init (e.g. React StrictMode)
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'PageView');
        return;
      }
      // Inject the official Meta Pixel snippet as a real &lt;script&gt; tag so the
      // browser executes it natively — this avoids any TS/bundler quirks with
      // the `arguments` object inside the IIFE.
      const pixelScript = document.createElement('script');
      pixelScript.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1038896145376572');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(pixelScript);
      // Fallback noscript pixel for users without JS
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=1038896145376572&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.head.appendChild(noscript);
    } catch (err) {
      // Never let pixel errors crash the page
      console.warn('Meta Pixel init failed:', err);
    }
  }, []);
  const handleWhatsAppClick = () => {
    try {
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'Contact');
      }
    } catch (err) {
      console.warn('Meta Pixel click track failed:', err);
    }
  };
  return <div className="relative w-full min-h-screen bg-black font-['Inter',sans-serif] text-white selection:bg-yellow-500/30 pb-12" data-id="element-13">
      {/* Background Image */}
      <div className="fixed inset-0 z-0 bg-cover bg-center bg-no-repeat opacity-40" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?q=80&w=1200&auto=format&fit=crop")'
    }} aria-hidden="true" data-id="element-14" />
      <div className="fixed inset-0 z-0 bg-gradient-to-b from-black/85 via-black/60 to-black/95" aria-hidden="true" data-id="element-15" />

      {/* Main Content Container */}
      <div className="relative z-10 w-full max-w-md mx-auto px-5 pt-8 flex flex-col gap-8" data-id="element-16">
        {/* Header Section */}
        <div className="text-center space-y-4" data-id="element-17">
          <h1 className="font-['Cinzel',serif] text-2xl sm:text-3xl font-bold text-[#D4AF37] leading-tight text-shadow-md uppercase tracking-wide" data-id="element-18">
            ¿Por qué tu amor, tu dinero o tu vida no avanzan?
          </h1>
          <h2 className="font-['Cinzel',serif] text-lg sm:text-xl font-semibold text-yellow-100 text-shadow-sm uppercase tracking-wider" data-id="element-19">
            Pregúntale a las cartas del tarot ahora...
          </h2>
          <p className="text-sm sm:text-base text-gray-200 leading-snug max-w-[95%] mx-auto text-shadow-sm" data-id="element-20">
            🔮 Descubre qué está bloqueando tu amor, tu dinero, tu salud o tu
            energía espiritual en una consulta privada.
          </p>
        </div>

        {/* Tarot Carousel */}
        <TarotCarousel data-id="element-21" />

        {/* What might be happening */}
        <div className="space-y-4" data-id="element-22">
          <h3 className="font-['Cinzel',serif] text-center text-base sm:text-lg font-semibold text-[#D4AF37] tracking-widest uppercase" data-id="element-23">
            Lo que puede estar pasando en tu vida
          </h3>
          <div className="space-y-3 bg-black/40 backdrop-blur-md p-4 rounded-2xl border border-[#D4AF37]/30 shadow-[0_0_20px_rgba(0,0,0,0.5)]" data-id="element-24">
            <div className="flex items-start gap-3" data-id="element-25">
              <span className="text-lg leading-none mt-0.5" data-id="element-26">❤️</span>
              <span className="text-sm sm:text-base text-gray-100" data-id="element-27">
                Conflictos o distancia en tu relación
              </span>
            </div>
            <div className="w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/20 to-transparent" data-id="element-28" />
            <div className="flex items-start gap-3" data-id="element-29">
              <span className="text-lg leading-none mt-0.5" data-id="element-30">💰</span>
              <span className="text-sm sm:text-base text-gray-100" data-id="element-31">
                Estancamiento económico o falta de dinero
              </span>
            </div>
            <div className="w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/20 to-transparent" data-id="element-32" />
            <div className="flex items-start gap-3" data-id="element-33">
              <span className="text-lg leading-none mt-0.5" data-id="element-34">🌿</span>
              <span className="text-sm sm:text-base text-gray-100" data-id="element-35">
                Ansiedad, preocupación o energía pesada
              </span>
            </div>
            <div className="w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/20 to-transparent" data-id="element-36" />
            <div className="flex items-start gap-3" data-id="element-37">
              <span className="text-lg leading-none mt-0.5" data-id="element-38">✨</span>
              <span className="text-sm sm:text-base text-gray-100" data-id="element-39">
                Bloqueos espirituales que no ves pero se repiten
              </span>
            </div>
          </div>
        </div>

        {/* Private Consultation & Price */}
        <div className="text-center space-y-4 bg-gradient-to-b from-black/60 to-black/40 backdrop-blur-md p-6 rounded-2xl border border-[#D4AF37]/40 shadow-[0_0_25px_rgba(212,175,55,0.15)]" data-id="element-40">
          <h3 className="font-['Cinzel',serif] text-lg sm:text-xl font-bold text-white tracking-widest uppercase" data-id="element-41">
            Consulta Privada Personalizada
          </h3>

          <motion.div animate={{
          scale: [1, 1.05, 1],
          textShadow: ['0px 0px 10px rgba(212,175,55,0.4)', '0px 0px 25px rgba(212,175,55,0.9)', '0px 0px 10px rgba(212,175,55,0.4)']
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="text-3xl sm:text-4xl font-['Cinzel',serif] font-bold text-[#D4AF37] my-4" data-id="element-42">
            🔥 SOLO $5.000 ARS
          </motion.div>

          <div className="space-y-2 text-sm sm:text-base text-gray-200" data-id="element-43">
            <p data-id="element-44">📲 Atención directa y privada por WhatsApp</p>
            <p data-id="element-45">🔒 Total confidencialidad</p>
          </div>
        </div>

        {/* First CTA Button */}
        <div data-id="element-46">
          <CTAButton onClick={handleWhatsAppClick} data-id="element-47" />
        </div>

        {/* Testimonials */}
        <div className="space-y-4" data-id="element-48">
          <h3 className="font-['Cinzel',serif] text-center text-base sm:text-lg font-semibold text-[#D4AF37] tracking-widest uppercase" data-id="element-49">
            Testimonios
          </h3>
          <TestimonialCarousel data-id="element-50" />
        </div>

        {/* Final CTA Section */}
        <div className="text-center space-y-4" data-id="element-51">
          <motion.p className="text-sm sm:text-base font-medium text-yellow-200" animate={{
          opacity: [0.7, 1, 0.7]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-52">
            👇 Escríbeme ahora y recibe tu consulta personalizada
          </motion.p>
          <CTAButton onClick={handleWhatsAppClick} data-id="element-53" />
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <motion.a href="https://wa.me/5491140680259" target="_blank" rel="noopener noreferrer" onClick={handleWhatsAppClick} aria-label="Consultar por WhatsApp" className="fixed bottom-5 right-5 z-50 flex items-center justify-center" animate={{
      scale: [1, 1.12, 1]
    }} transition={{
      duration: 1.4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-54">
        {/* Pulsing rings */}
        <motion.span className="absolute inset-0 rounded-full bg-[#25D366]" animate={{
        scale: [1, 1.8],
        opacity: [0.5, 0]
      }} transition={{
        duration: 1.6,
        repeat: Infinity,
        ease: 'easeOut'
      }} aria-hidden="true" data-id="element-55" />
        <motion.span className="absolute inset-0 rounded-full bg-[#25D366]" animate={{
        scale: [1, 1.8],
        opacity: [0.5, 0]
      }} transition={{
        duration: 1.6,
        repeat: Infinity,
        ease: 'easeOut',
        delay: 0.8
      }} aria-hidden="true" data-id="element-56" />
        {/* Button */}
        <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-[0_0_20px_rgba(37,211,102,0.7)] border-2 border-white/30" data-id="element-57">
          <svg viewBox="0 0 24 24" className="w-8 h-8 fill-white" aria-hidden="true" data-id="element-58">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-59" />
          </svg>
        </span>
      </motion.a>
    </div>;
}